<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/retail-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">实体门店面临的烦恼</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/retail01.png" alt="">
          店铺各自创建商品，信息无法共享
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/retail02.png" alt="">
          店铺自定义价格，商家无法统一管控
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/retail03.png" alt="">
          多店铺共用仓库，无法共享库存
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/retail04.png" alt="">
          员工管理混乱，账目理不清
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">满足多种店铺类型经营需求</div>
      </div>
      <img src="@/assets/Mobile/images/solution/retail05.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">商家统一分发，店铺自行创建</div>
      </div>
      <img src="@/assets/Mobile/images/solution/retail06.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">商家库存共享，店铺库存独享</div>
      </div>
      <img src="@/assets/Mobile/images/solution/retail07.png" alt="">
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">员工垂直管，组织明确分工</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/solution/retail08.png" alt="">
        <img src="@/assets/Mobile/images/solution/retail09.png" alt="">
      </div>
    </div>
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">连锁营销，多店联动</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/solution/retail10.png" alt="">
        <img src="@/assets/Mobile/images/solution/retail11.png" alt="">
        <img src="@/assets/Mobile/images/solution/retail12.png" alt="">
        <img src="@/assets/Mobile/images/solution/retail13.png" alt="">
      </div>
    </div>
    <div class="block07">
      <div class="sk-mobile-title">
        <div class="title">数据统一管，账目清晰明了</div>
      </div>
      <img src="@/assets/Mobile/images/solution/retail14.png" alt="">
    </div>
    <IndustrySolution />
    <Case title="连锁电商" />
    <ContactForm info-sources="连锁电商" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.ChainE,
  components: {
    ContactForm,
    IndustrySolution,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    justify-content: space-evenly;
    .item {
      width: 69px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      line-height: 11px;
      font-size: 8px;
      font-weight: 500;
      color: #595961;
    }
    img {
      width: 54px;
    }
  }
}
.block02 {
  img {
    width: 342px;
    margin: 20px 0 22px 0;
  }
}
.block03 {
  background-color: #FAFAFA;
  img {
    width: 341px;
    margin: 22px 0 12px 0;
  }
}
.block04 {
  img {
    width: 343px;
    margin-top: 19px;
  }
}
.block05 {
  background-color: #FAFAFA;
  .content {
    padding: 24px 0 14px 0;
    img {
      width: 343px;
      margin-bottom: 10px;
    }
  }
}
.block06 {
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    img {
      width: 164px;
      height: 160px;
      margin: 12px 3px 6px;
    }
  }
}
.block07 {
  background-color: #FAFAFA;
  img {
    width: 339px;
    margin-top: 25px;
  }
}
</style>
